import React, { useCallback, useState } from 'react';

import { IconButton } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';

import { Card, Filter } from './components';
import * as S from './styles';

export default function EstoquePostoMonitor() {
  const [params, setParams] = useState({});

  // open new window
  const handleOpennewWindow = useCallback(() => {
    window.open(
      'dlgEstoquePostoMonitor_fullscreen',
      '_blank',
      'toolbar=0,location=0,menubar=0'
    );
  }, []);

  return (
    <S.Wrapper>
      <S.Header>
        {/* <Filter onCallback={setParams} /> */}

        <IconButton
          aria-label="Abrir nova janela"
          onClick={handleOpennewWindow}
        >
          <OpenInNew />
        </IconButton>
      </S.Header>

      <Card params={params} />
    </S.Wrapper>
  );
}
/*import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/estoquePostoMonitor/actions';

import MyForm from './form';

function EstoquePostoMonitor() {
  const redux = useSelector((state) => state.estoquePostoMonitor);

  const header = useMemo(
    () => [{ id: 'rownum', label: 'Row' }],
    []
  );

  return (
    <UnidataTable
      fixed
      header={header}
      read={recordFiltering}
      remove={deleteData}
      find={findData}
      form={MyForm}
      redux={redux}
      title="Dlg Estoque Posto Monitor"
      detach="rownum"
      keys={['rownum']}
    />
  );
}

export default EstoquePostoMonitor;
/*

/*
import React, { useCallback, useState } from 'react';

import { IconButton } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';

import { Card, Filter } from './components';
import * as S from './styles';

export default function EstoquePostoMonitor() {
  const [params, setParams] = useState({});

  // open new window
  const handleOpennewWindow = useCallback(() => {
    window.open(
      'monitoramento_alertas_fullscreen',
      '_blank',
      'toolbar=0,location=0,menubar=0'
    );
  }, []);

  return (
    <S.Wrapper>
      <S.Header>
        <Filter onCallback={setParams} />

        <IconButton
          aria-label="Abrir nova janela"
          onClick={handleOpennewWindow}
        >
          <OpenInNew />
        </IconButton>
      </S.Header>

      <Card params={params} />
    </S.Wrapper>
  );
}


*/
